const WASM_SIMD_PROBE = new Uint8Array([
  0x00, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00, 0x01, 0x04, 0x01, 0x60, 0x00, 0x00, 0x03, 0x02,
  0x01, 0x00, 0x0a, 0x09, 0x01, 0x07, 0x00, 0x41, 0x00, 0xfd, 0x0f, 0x1a, 0x0b,
]);

let wasmSimdSupported: boolean | null = null;

export function supportsWasmSimd(): boolean {
  if (wasmSimdSupported != null) return wasmSimdSupported;
  try {
    wasmSimdSupported = typeof WebAssembly !== "undefined" && WebAssembly.validate(WASM_SIMD_PROBE);
  } catch {
    wasmSimdSupported = false;
  }
  return wasmSimdSupported;
}
